var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('DialogoFormulario',{ref:"dialogo",attrs:{"title":"Nova Locação","width":400,"handler":_vm.handleSubmit},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var form = ref.form;
var errors = ref.errors;
return [_c('BuscarOuCadastrarLocalDeEstoque',{attrs:{"label":"Local de estoque destino","outlined":""},model:{value:(form.local_estoque),callback:function ($$v) {_vm.$set(form, "local_estoque", $$v)},expression:"form.local_estoque"}})]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }